import useEffectWithOptions from "./useEffectWithOptions";
import UseEffectOptions from "./UseEffectOptions";

export default function useDidMountWillUnmountEffect(effect: () => () => void, options?: UseEffectOptions): void {
    return useEffectWithOptions(effect, [], options);
}
